exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quality-inspection-standard[data-v-69d11a94]{position:relative;width:100%}.quality-inspection-standard .quality-edit-table[data-v-69d11a94] .ivu-table-tbody .ivu-form-item{margin-bottom:0;width:100%}", ""]);

// exports
